import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalPageProjectScenarioStore = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.PageProjectScenarioStore />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalPageProjectScenarioStore = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalPageProjectScenarioStore />
    </Suspense>
  );
};
